module.exports = __webpack_public_path__ + "media/icons/calendar-046640bf.png";